import axios from 'axios';
import { APISettings } from '../../config/ApiSettings';
const baseFunctionUrl = new APISettings().getSearchFunctionURL();

class SearchFuncApi {
  //   constructor() {}

  public httpSearchFunction: (functionName: string, body: any) => Promise<string> = async (
    functionName: string,
    body: any
  ) => {
    let url = `${baseFunctionUrl}/${functionName}`;
    return await axios.post(`${url}`, body);
  };
}

export const searchFuncApi = new SearchFuncApi();
